export default "__VITE_PUBLIC_ASSET__4f0cb1f0__"